import React, { useState, useEffect, useRef } from "react";
import { Carousel } from "antd";

import axios from "axios";

import arrowleft from "../../Images/arrowleft.png";
import arrowright from "../../Images/arrowright.png";
import { useLocation, useParams, useHistory } from "react-router-dom";
import Rating from "@mui/material/Rating";
import Pagination from "@mui/material/Pagination";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";

export default function AllCategoriesReviews({ CategoryName }) {
  const { t, i18n } = useTranslation();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  const handleDivClick2 = (CategoryName, ProductId) => {
    CreateRecently(ProductId);
    history.push(`/product/${ProductId}`);
  };
  const CreateRecently = (IdOfProduct) => {
    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB").split("/").join("-");
    const formattedTime = now.toTimeString().slice(0, 5);

    const data = {
      UserId: user?.userId,
      ProductId: IdOfProduct,
      TheDate: formattedDate,
      TheTime: formattedTime,
    };
    axios
      .post(`${MyDomain}Recently/CreateRecently`, data) // API URL for adding products to the cart
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log("Error adding product to cart:", error);
      });
  };
  const history = useHistory();

  const location = useLocation();
  const { CategoryTitle } = location.state || {}; // Access the passed state
  // const { CategoryName } = useParams();

  const wrapperRef = useRef();

  const [ProductsData, setProductsData] = useState([]);
  const [ProductsDataWithoutDub, setProductsDataWithoutDub] = useState([]);
  const [ProductsLoading, setProductsLoading] = useState(true);
  const [ProductsError, setProductsError] = useState(null);

  useEffect(() => {
    const data = {
      CodeCat: CategoryName,
    };

    // Fetch data when the component mounts
    axios
      .post(`${MyDomain}Reviews/GetReviewsByCategory`, data) // Replace with your API endpoint
      .then((response) => {
        console.log(response.data);
        setProductsData(response.data); // Store the data
        setProductsLoading(false); // Set loading to false
      })
      .catch((error) => {
        setProductsError(error); // Handle any errors
        setProductsLoading(false);
      });
  }, []); // Empty dependency array ensures this effect runs once on mount

  const [currentSlide, setCurrentSlide] = useState(0);
  const carouselRef = React.createRef();

  const next = () => {
    carouselRef.current.next();
  };

  const prev = () => {
    carouselRef.current.prev();
  };

  const handleBeforeChange = (from, to) => {
    setCurrentSlide(to);
  };

  // Function to group products into chunks of specified size
  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };
  const numItemsPerSlide = MyWidth <= 1024 ? 1 : MyWidth <= 1440 ? 3 : 4; // Change this to 4 if you want 4 items per slide
  const slides = chunkArray(ProductsData, numItemsPerSlide); // Grouping products into chunks of 4

  function ProductCard({
    Id,
    ReviewComment,
    ReviewDate,
    ReviewTime,
    ProductOBJ,
    UserOBJ,
    ReviewRating,
  }) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          cursor: "pointer",
        }}
        onClick={() => {
          handleDivClick2("product", ProductOBJ?.id);
        }}
      >
        {/* Product Section */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "10px", // Added padding for flexibility
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              src={ProductOBJ?.image}
              alt={ProductOBJ?.name}
              style={{
                width: "50%", // Adjust width as needed
                height: "auto",
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "10%",
                width: "100%", // Adjusted width for a flexible layout
              }}
            >
              <a style={{ fontWeight: "500", marginBottom: "5px" }}>
                {ProductOBJ?.name}
              </a>
              <a>{ProductOBJ?.dropDown}</a>
            </div>
          </div>
        </div>

        {/* Review Section */}
        <div
          style={{
            paddingLeft: "2%",
            paddingRight: "2%",
            backgroundColor: "#fafafa",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              wordBreak: "break-word",
              paddingBottom: 20,
              height: "auto", // Allow dynamic height based on content
              paddingTop: 10,
            }}
          >
            {ReviewComment}
          </div>

          {/* User Info Section */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              padding: "10px", // Added padding for flexibility
            }}
          >
            <div style={{ width: "50%" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingRight: "2%",
                  width: "30%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#e5e5e5", // Dynamic background color
                    color: "white",
                    fontSize: "20px", // Can adjust the font size
                    fontWeight: "500",
                    borderRadius: "50%",
                    width: "35px", // Dynamic size for better adaptability
                    height: "35px",
                  }}
                >
                  {UserOBJ.firstName.charAt(0).toUpperCase()}
                </div>
              </div>
              <div>
                <div>
                  {UserOBJ.firstName} {UserOBJ.lastName}
                </div>
                <div>
                  {ReviewDate}, {ReviewTime}
                </div>
              </div>
            </div>
            <div
              style={{
                width: "50%",
                alignItems: "center",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Rating
                name="read-only"
                value={ReviewRating}
                readOnly
                sx={{
                  // Make stars bigger
                  fontSize: "0.75rem", // Adjust size (e.g., 1.5rem, 2rem, etc.)

                  // Add space between stars
                  "& .MuiRating-icon": {
                    color: "black", // Black stars
                    paddingRight: "0 2px", // Adjust spacing (e.g., 0 8px for more space)
                    paddingTop: 1,
                  },

                  // Ensure filled/hover stars are also black
                  "& .MuiRating-iconFilled": {
                    color: "black",
                  },
                  "& .MuiRating-iconHover": {
                    color: "black",
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div
      style={{
        position: "relative",
        paddingTop: "100px",
        paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
        paddingRight: MyWidth <= 1024 ? "2%" : "0%",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <div
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          display: "flex",
          justifyItems: "center",
        }}
      >
        {MyWidth <= 1024 ? (
          <></>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <a style={{ fontWeight: "500", fontSize: 25 }}>{"         "}</a>
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: MyWidth <= 1024 ? "flex-start" : "center",
            alignItems: "center",
          }}
        >
          <a
            style={{ fontWeight: "bold", fontSize: MyWidth <= 1024 ? 15 : 25 }}
          >
            {t("profile.Reviewson")} {CategoryTitle}
          </a>
        </div>
        <div style={{ alignItems: "center", display: "flex" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingRight: 30,
            }}
            onClick={prev}
          >
            <img
              src={arrowleft}
              style={{
                width: 35,
                height: 35,
                opacity: currentSlide === 0 ? 0.3 : 1,
                cursor: currentSlide === 0 ? "" : "pointer",
              }}
            />
          </div>
          <div
            style={{
              //backgroundColor: "#fafafa",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={next}
          >
            <img
              src={arrowright}
              style={{
                width: 35,
                height: 35,
                opacity: currentSlide === slides.length - 1 ? 0.3 : 1,
                cursor: currentSlide === slides.length - 1 ? "" : "pointer",
              }}
            />
          </div>
        </div>
      </div>
      <div ref={wrapperRef}>
        <Carousel
          arrows={false}
          infinite={false}
          ref={carouselRef}
          beforeChange={handleBeforeChange}
          dots={false}
        >
          {slides.map((slide, index) => (
            <div>
              <div
                key={index}
                style={{
                  display: "flex",
                  //justifyContent: "space-between",
                  justifyContent: "flex-start",
                  width: "100%",
                  direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                }}
              >
                {slide.map((image, imgIndex) => {
                  const globalIndex = index * numItemsPerSlide + imgIndex;
                  return (
                    <div
                      style={{
                        marginRight:
                          i18n.resolvedLanguage === "en"
                            ? (imgIndex + 1) % numItemsPerSlide === 0
                              ? 0
                              : 20
                            : 0,

                        marginLeft:
                          i18n.resolvedLanguage === "en"
                            ? 0
                            : (imgIndex + 1) % numItemsPerSlide === 0
                            ? 0
                            : 20,
                        width: "100%",
                      }}
                    >
                      <ProductCard
                        key={globalIndex}
                        Id={ProductsData[globalIndex].reviewId}
                        ReviewComment={ProductsData[globalIndex].reviewComment}
                        ReviewDate={ProductsData[globalIndex].reviewDate}
                        ReviewTime={ProductsData[globalIndex].reviewTime}
                        ProductOBJ={ProductsData[globalIndex].product}
                        UserOBJ={ProductsData[globalIndex].user}
                        ReviewRating={ProductsData[globalIndex].reviewRating}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
}
